import React from 'react'
import './forms.scss'
import PropTypes from 'prop-types'

function ContactForm({ Field, submit, error, touched }) {
   return (
      <form onSubmit={submit}>
         <div className="joint">
            <div className="form__group">
               <label htmlFor="name">
                  {error.name && touched.name ? (
                     <small className="error">{error.name}</small>
                  ) : (
                     'Name'
                  )}
               </label>
               <Field
                  name="name"
                  type="text"
                  className="form__group--input"
                  placeholder="someone"
               />
            </div>
            <div className="form__group">
               <label htmlFor="email">
                  {error.email && touched.email ? (
                     <small className="error">{error.email}</small>
                  ) : (
                     'Email'
                  )}
               </label>
               <Field
                  name="email"
                  type="email"
                  className="form__group--input"
                  placeholder="someone@gmail.com"
               />
            </div>
         </div>
         <div className="form__group">
            <label htmlFor="message">
               {error.message && touched.message ? (
                  <small className="error">{error.message}</small>
               ) : (
                  'Message'
               )}
            </label>
            <Field
               name="message"
               as="textarea"
               className="form__group--input textarea"
               placeholder="start typing..."
            />
         </div>
         <div className="form__group">
            <button type="submit" onSubmit={submit} className="btn btn__submit">
               <span>Submit</span>
            </button>
         </div>
      </form>
   )
}

ContactForm.propTypes = {
   submit: PropTypes.func.isRequired,
   error: PropTypes.object.isRequired,
   touched: PropTypes.object.isRequired,
}
ContactForm.defaultProps = {
   submit: () => {},
   error: {},
   touched: {},
}

export default ContactForm
